<template>
  <div v-if="periodList().length > 0">
    <p style="margin: 20px 0 5px;">
      <strong class="avoid">Allotment</strong>
    </p>
    <table style=" border-collapse: collapse; border: 1px solid #cccccc; width: 100%; margin-bottom: 20px;">
      <tr style="background: #f3f3f3" class="avoid">
        <th style="border: 1px solid #cccccc; padding: 3px; font-weight: bold; text-align: left;">
          <p><strong>Validity Period</strong></p>
        </th>
        <th v-for="(roomTypeItem) of selectedRoomTypeList()"
            style="border: 1px solid #cccccc; padding: 3px; font-weight: bold; text-align: left;"
            :key="roomTypeItem.id">
          <p>{{roomTypeItem.name}}</p>
        </th>
        <th style="border: 1px solid #cccccc; padding: 3px; font-weight: bold; text-align: left;">
          <p><strong>Cuttoff Date</strong></p>
        </th>
      </tr>
      <tr v-for="(periodDate, index) of periodList()" class="avoid"
          :key="index">
        <td style="border: 1px solid #cccccc; padding: 3px;">
          <p>{{bindDateFromTo(periodDate.startDate, periodDate.endDate)}}</p>
        </td>
        <td v-for="(roomTypeItem) of selectedRoomTypeList()"
            :key="roomTypeItem.id"
            style="border: 1px solid #cccccc; padding: 3px;">
          <p>
            <span>
              {{bindAllotment(roomTypeItem.id, index)}}
            </span>
          </p>
        </td>
        <td style="border: 1px solid #cccccc; padding: 3px;">
          <p>
            {{bindCutOffDate(periodDate.startDate)}}
          </p>
        </td>
      </tr>
    </table>
    <div v-if="bindAllotmentRemark().trim() !== ''" class="editor-preview avoid">
      <p style="margin: 5px 0 5px;">
        <strong>Remark: </strong>
      </p>
      <div v-html="bindAllotmentRemark()"></div>
    </div>
  </div>
</template>
<script>
import { REMARK_TYPE } from '@/configs/constant'
import { getISODateFormat, numberFormat } from '@/helpers'
import { isValidStartEndInPeriod, getPeriodStartDate, getPeriodEndDate, dateFormat } from '@/helpers/datetime'
import { get } from 'lodash'
import { applyRemarkTableStyle } from '@/domains/contract-domain'

export default {
  name: 'Allotment',
  props: {
    contractStartDate: {
      type: String,
      default: ''
    },
    contractEndDate: {
      type: String,
      default: ''
    },
    allotmentList: {
      type: Array,
      default: () => {
        return []
      }
    },
    cutOffDateList: {
      type: Array,
      default: () => {
        return []
      }
    },
    remarkList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
      periodList: () => {
        const contractStartDate = this.contractStartDate
        const contractEndDate = this.contractEndDate
        const periodKeyList = []
        const periodList = []

        for (let allotmentItem of this.allotmentList) {
          if (isValidStartEndInPeriod(contractStartDate, contractEndDate, allotmentItem.startDate, allotmentItem.endDate)) {
            const startDate = getPeriodStartDate(contractStartDate, allotmentItem.startDate)
            const endDate = getPeriodEndDate(contractEndDate, allotmentItem.endDate)

            const startDateStr = getISODateFormat(new Date(startDate))
            const endDateStr = getISODateFormat(new Date(endDate))
            const periodKey = `${startDateStr}_${endDateStr}`

            if (!periodKeyList.includes(periodKey)) {
              periodKeyList.push(periodKey)
              const period = {
                startDate: startDateStr,
                endDate: endDateStr
              }

              periodList.push(period)
            }
          }
        }

        return periodList
      },
      allotmentByRoomByPeriodList: () => {
        const allotmentByRoomByPeriodList = {}
        const periodKeyList = []

        for (let allotmentItem of this.allotmentList) {
          if (isValidStartEndInPeriod(this.contractStartDate, this.contractEndDate, allotmentItem.startDate, allotmentItem.endDate)) {
            const startDate = getISODateFormat(new Date(allotmentItem.startDate))
            const endDate = getISODateFormat(new Date(allotmentItem.endDate))
            const roomTypeId = allotmentItem.roomTypeId
            const allotment = allotmentItem.allotment
            const periodKey = `${startDate}_${endDate}`

            if (!periodKeyList.includes(periodKey)) {
              periodKeyList.push(periodKey)
            }

            const periodIndex = periodKeyList.indexOf(periodKey)
            if (allotmentByRoomByPeriodList[roomTypeId] === undefined) {
              allotmentByRoomByPeriodList[roomTypeId] = {}
              allotmentByRoomByPeriodList[roomTypeId][periodIndex] = allotment
            } else {
              allotmentByRoomByPeriodList[roomTypeId][periodIndex] = allotment
            }
          }
        }

        return allotmentByRoomByPeriodList
      },
      selectedRoomTypeList: () => {
        const selectedRoomTypeIdList = []
        const selectedRoomTypeItemList = []
        const periodKeyList = []

        for (let allotmentItem of this.allotmentList) {
          if (isValidStartEndInPeriod(this.contractStartDate, this.contractEndDate, allotmentItem.startDate, allotmentItem.endDate)) {
            const startDate = getISODateFormat(new Date(allotmentItem.startDate))
            const endDate = getISODateFormat(new Date(allotmentItem.endDate))
            const roomTypeId = allotmentItem.roomTypeId
            const roomTypeName = allotmentItem.roomTypeName
            const periodKey = `${startDate}_${endDate}`

            if (!periodKeyList.includes(periodKey)) {
              periodKeyList.push(periodKey)
            }

            if (!selectedRoomTypeIdList.includes(roomTypeId)) {
              selectedRoomTypeIdList.push(roomTypeId)
              selectedRoomTypeItemList.push({ id: roomTypeId, name: roomTypeName })
            }
          }
        }

        return this.sortingRoomType(selectedRoomTypeItemList)
      },
      numberFormat: (number) => {
        return numberFormat(number)
      }
    }
  },
  methods: {
    bindDateFromTo: function (startDateStr, endDateStr) {
      let dateFromToStr = '-'
      if (startDateStr !== '' && endDateStr !== '') {
        const startDate = new Date(startDateStr)
        const endDate = new Date(endDateStr)
        dateFromToStr = `${dateFormat.short(startDate, 'en')} - ${dateFormat.short(endDate, 'en')}`
      }

      return dateFromToStr
    },
    sortingRoomType: function (roomTypeList) {
      let sortedRoomType = []
      if (roomTypeList.length > 0) {
        sortedRoomType = roomTypeList.sort((a, b) => {
          return (a.name < b.name) ? -1 : 1
        })
      }

      return sortedRoomType
    },
    bindAllotment: function (roomTypeId, index) {
      const allotment = get(this.allotmentByRoomByPeriodList(), `${roomTypeId}.${index}`, '')

      return (allotment === '') ? '-' : numberFormat(allotment)
    },
    bindCutOffDate: function (periodStart) {
      for (let index in this.cutOffDateList) {
        const cutOffStartDate = new Date(this.cutOffDateList[index].startDate)
        const cutOffEndDate = new Date(this.cutOffDateList[index].endDate)
        const periodStartDate = new Date(periodStart)
        if (periodStartDate.getTime() >= cutOffStartDate.getTime() && periodStartDate.getTime() <= cutOffEndDate.getTime()) {
          return this.cutOffDateList[index].cutOffDate
        }
      }
      return '-'
    },
    bindAllotmentRemark: function () {
      const remark = applyRemarkTableStyle(this.remarkList, REMARK_TYPE.ALLOTMENT)

      return remark
    }
  }
}
</script>
<style scoped>
  p {
    display: block;
    margin-block-start: 0px;
    margin-block-end:0px;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
  }
  .remark > p {
    margin: 5px 0 10px;
  }
</style>
